module.exports = __webpack_public_path__ + "static/img/map0824.006c4c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map0824.jpg
// module id = NI6I
// module chunks = 0